/**
 * Internal dependencies
 */
import getInProgressOperation from './get-in-progress-operation';

export default (state) => {
	let operation = getInProgressOperation(state);
	return !operation || 'pending' === operation.status || 'processing' === operation.status;
};
